module.exports = __webpack_public_path__ + "static/media/more.7b3e2fac.svg";